module.exports = __webpack_public_path__ + "media/src/images/scopestack-logo-a2b8101d668dac2c846c7579bf026ada.png";